module.exports = __webpack_public_path__ + "static/img/passed.88c2bdeb.png";